import { Component, Input, ElementRef, ViewChild } from '@angular/core';

declare var bootstrap: any;

@Component({
  selector: 'app-modal-imagen',
  templateUrl: './modal-imagen.component.html',
  styleUrls: ['./modal-imagen.component.scss']
})
export class ModalImagenComponent {

  @Input() imagenSrc: string = ''; // recibe la imagen
  @ViewChild('modalRef') modalRef!: ElementRef;

  modalInstance: any;

  ngAfterViewInit() {
    this.modalInstance = new bootstrap.Modal(this.modalRef.nativeElement, {
      keyboard: true
    });
  }

  abrirModal(imagen: string) {
    this.imagenSrc = imagen;
    this.modalInstance.show();
  }

  cerrarModal() {
    this.modalInstance.hide();
  }

}
